module.exports = __webpack_public_path__ + "static/img/bg-id.3e573886.png";